export const error404 = {
  title: {
    en: 'Not Found(404)',
    ko: '찾을 수 없음(404)',
    fr: '',
  },
  content: {
    en: 'Sorry. Page not found.',
    ko: '죄송합니다. 해당 페이지를 찾을 수 없습니다.',
    fr: '',
  },
  button: {
    back: {
      en: 'Previous page',
      ko: '이전 페이지로',
      fr: '',
    },
  },
};
